export const getOrganizations = () =>
  fetch(`/organizations.json?view=minimal`)
    .then(response => response.json());

export const getExportTemplates = (organizationId) =>
  fetch(`/organizations/${organizationId}/export_templates.json?view=minimal`)
    .then(response => response.json());
